module.exports = __webpack_public_path__ + "img/point.6d3463ab.svg";